import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios'
import { API_BASE_URL } from '../config';
// Backend API'nizin temel URL'si
// ÖNEMLİ: Bu satırı 8000'den 8001'e güncelleyin!


const AuthContext = React.createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          // Bu istek artık doğru adrese gidecek: http://localhost:8001/api/me
          const response = await axios.get(`${API_BASE_URL}/me`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          // AuthController'dan dönen yapı { success: true, user: {...} } şeklinde
          setUser(response.data.user) //
        } catch (error) {
          console.error("Token'la kullanıcı bilgisi alınamadı. Token geçersiz olabilir.", error)
          localStorage.removeItem('token')
          setUser(null)
        }
      }
      setLoading(false)
    }

    fetchUser()
  }, [])

  // login ve logout fonksiyonlarınız burada...
  const login = (userData, token) => {
    localStorage.setItem('token', token)
    setUser(userData)
  }

  const logout = async () => {
    const token = localStorage.getItem('token')
    if (token) {
      try {
        await axios.post(
          `${API_BASE_URL}/logout`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
      } catch (error) {
        console.error('Logout sırasında hata:', error)
      }
    }
    localStorage.removeItem('token')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  return React.useContext(AuthContext)
}
